/* eslint-disable max-lines */
import FilterListHeaderRedesign from 'components/Filters/FilterListHeaderRedesign';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';

const AdditionalUsersHeaders: React.FC = () => (
  <thead className="sticky top-0 z-10">
    <tr className="table-wrapper__header-tr h-10">
      <FilterListHeaderRedesign
        resource={resourceQueryParamName.user}
        text="Name"
        field="name"
        className="table-wrapper__new-th table-wrapper__th--w-22 pl-4"
      />
      <th className="table-wrapper__new-th table-wrapper__th--w-24">Email</th>
      <th className="table-wrapper__new-th table-wrapper__th--w-22">Domain</th>
      <th className="table-wrapper__new-th">On Risk</th>
    </tr>
  </thead>
);

export default AdditionalUsersHeaders;
